import { Box, Checkbox, useTheme } from '@mui/material'

import { FormControlLabel } from 'Features/OperationalPlanner/WorkcentreModal/FormControlLabel/FormControlLabel.view'
import {
  isAllSourceSitesSelected,
  isSomeSourceSitesSelected,
  isAllProductCountsInSourcesitesZero,
} from 'Features/OperationalPlanner/WorkcentreModal/WorkcentreModal.utils'
import { SourceSiteSelectionControlProps } from 'Features/OperationalPlanner/WorkcentreModal/SourceSiteSelectionControl/SourceSiteSelectionControl.types'

export const SourceSiteSelectionControl = ({
  sourceSiteDetails,
  handleCheckboxChange,
}: SourceSiteSelectionControlProps) => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        marginLeft: '16px',
        marginBottom: '15px',
      }}
    >
      <FormControlLabel
        label="Select all source sites"
        slotProps={{
          typography: {
            sx: {
              fontSize: '18px',
              fontWeight: 'bold',
            },
          },
        }}
        control={
          <Checkbox
            disabled={isAllProductCountsInSourcesitesZero(sourceSiteDetails)}
            color="primary"
            indeterminate={isSomeSourceSitesSelected(sourceSiteDetails)}
            checked={isAllSourceSitesSelected(sourceSiteDetails)}
            sx={{
              color: theme.palette.primary.main,
            }}
            onChange={(event) => handleCheckboxChange(event)}
          />
        }
      />
    </Box>
  )
}
